import { ReactElement } from 'react'
import { useAccountContext } from '../../contexts/account-context'
import { useRecoilValue } from 'recoil'
import { accountState } from '../../states/account-state'

const Component = (): ReactElement => {
  const accountId = useAccountContext()
  const account = useRecoilValue(accountState(String(accountId)))

  console.log('account', account)

  return <div></div>
}

export const AccountKyc = Component